module.exports = "<p-panelMenu  [model]=\"menuItems\" ></p-panelMenu>"